
const emailSubscription = () => {
    const form = document.getElementById('subscribe-form');
    const formSubmitBtn = form.querySelector('button[type="submit"]');
    const spinner = document.querySelector('.spinner')

    if (form) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            spinner.classList.add('loading');
            formSubmitBtn.setAttribute('disabled', true);

            const userEmail = document.getElementById('user_email');

            const body = {
                user_email: userEmail.value,
            }

            fetch('/wp-json/wp-user/email-subscription', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
                .then(res => res.json())
                .then(() => {
                    formSubmitBtn.removeAttribute('disabled');
                    userEmail.value = '';
                    spinner.classList.remove('loading');
                })
        })
    }


}

export default emailSubscription;
